import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {PtserialBeansModel} from '../models/ptserial-beans.model';
import {LokijsService} from './database/lokijs.service';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';

@Injectable({
    providedIn: 'root'
})
export class ReleaseSerialsService {

    constructor(private loki: LokijsService) {
    }

    updateSerialsFromDoc(doc: DocumentModel) {
        const tempSerials = new Array<PtserialBeansModel>();
        for (const line of doc.detailLines) {
            if (line.plu) {
                if (line.ptSerialBeans) {
                    for (const serial of line.ptSerialBeans) {
                        serial.stat = 0;
                        tempSerials.push(serial);
                    }
                }
            }
        }
        this.loki.upsert('ptserial', 'id', tempSerials);
    }

    updateSerialsFromDetailLine(line: DetaillineDTOModel) {
        console.log(line);
        const tempSerials = new Array<PtserialBeansModel>();
        if (line.plu) {
            if (line.ptSerialBeans) {
                for (const serial of line.ptSerialBeans) {
                    serial.stat = 0;
                    tempSerials.push(serial);
                }
            }
        }
        this.loki.upsert('ptserial', 'id', tempSerials);
    }
}
